import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 

const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
    getActivityNHNEGetByPage({ rootState }, opt) { 
        return new Promise((resolve, reject) => {
          axios.post(`${config.api.reqApi}/api/Activity/NHNEGetByPage`, opt, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
      },
      getActivityNHNEGetById({ rootState }, id) { 
        return new Promise((resolve, reject) => {
          axios.get(`${config.api.reqApi}/api/Activity/NHNEGetByid?Id=${id}`, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
      },
      addActivityNHNE({ rootState }, opt) { // 添加活动
        return new Promise((resolve, reject) => {
          axios.post(`${config.api.reqApi}/api/Activity/NHNEAdd`, opt, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
      },
      getEnterpriseContactId({ rootState }, opt) { 
        return new Promise((resolve, reject) => {
          axios.get(`${config.api.reqApi}/api/CompanyActivityLink/GetByCompId?exhibitionId=${opt.exhibitionId}&compId=${opt.compId}`, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
      },
      addEnterpriseContact({ rootState }, opt) { // 添加企业联系方式
        return new Promise((resolve, reject) => {
          axios.post(`${config.api.reqApi}/api/CompanyActivityLink`, opt, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
      },
      editEnterpriseContact({ rootState }, opt) { // 修改企业联系方式
        return new Promise((resolve, reject) => {
          axios.put(`${config.api.reqApi}/api/CompanyActivityLink`, opt, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
      },
      editActivityNHNE({ rootState }, opt) { // 修改活动
        return new Promise((resolve, reject) => {
          axios.put(`${config.api.reqApi}/api/Activity/NHNEUpdate`, opt, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
      },
  getActivityByJoinId({ rootState }, opt) { // 通过joinId获取全部活动
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity/GetShortByJoinId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getActivityByJoinIdAll({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity/GetByJoinId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getActivityById({ rootState }, id) { // 根据id查询对应活动
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/activity/?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  setActivityShow({ rootState }, opt) { //修改活动屏蔽、显示
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/activity/SetShow`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  addActivity({ rootState }, opt) { // 添加活动
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delActivity({ rootState }, id) { // 删除活动
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/activity?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  editActivity({ rootState }, opt) { // 修改活动
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/Activity`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 